import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { SectionContainer } from '../ui/SectionContainer';
import { StepItem } from '../ui/StepItem';
import { HOW_IT_WORKS_STEPS } from '../../constants';

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

/**
 * How It Works section displaying the 6-step feedback collection process
 */
export const HowItWorksSection: React.FC = () => {
  return (
    <SectionContainer id="how-it-works" variant="default">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-50px' }}
        transition={{ duration: 0.6 }}
      >
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '2rem', md: '2.5rem' },
            }}
          >
            How It Works
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
            From survey creation to actionable insights in six simple steps
          </Typography>
        </Box>
      </motion.div>

      <Grid
        container
        spacing={4}
        component={motion.div}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-50px' }}
      >
        {HOW_IT_WORKS_STEPS.map((step) => (
          <Grid
            item
            key={step.number}
            xs={12}
            sm={6}
            md={4}
            component={motion.div}
            variants={itemVariants}
          >
            <StepItem number={step.number} title={step.title} description={step.description} />
          </Grid>
        ))}
      </Grid>
    </SectionContainer>
  );
};
